export const SUPPORTED_DATA_TYPES = new Set([
    'ClassicSectionA11y',
    'StripColumnsContainerA11y',
    'TextInputA11y',
    'BasicMenuItem',
    'CustomMenuDataRefA11y',
    'FacebookShareButton',
    'LinkableButton',
    'PinterestFollow',
    'FileUploader',
    'SiteButtonA11y',
    'SiteButton',
    'SiteButtonData',
    'StyledTextA11y',
    'ButtonWithIcon',
    'RepeaterA11y',
    'ImageButtonWithText',
    'LightboxA11y',
    'ContainerA11y',
    'MultiStateBoxDataA11y',
    'mobui.MobuiButton',
    'mobui.MobuiPicker',
    'MobuiPickerItemType',
    'mobui.MobuiTextInput',
    'wixui.RangeSlider',
    'IShareButton',
    'wixui.SingleTab',
    'AddressInput',
    'SelectionTag',
    'StylableButton',
    'StylableButtonA11y',
    'defaultItemSchemaType',
    'dsgnsys.DashboardButton',
    'dsgnsys.DashboardInput',
    'dsgnsys.DashboardNumberInput',
    'dsgnsys.DashboardTextButton',
    'dsgnsys.DashboardToggleSwitch',
    'dsgnsys.WbuAccordion',
    'dsgnsys.WbuBackButton',
    'dsgnsys.WbuButton',
    'dsgnsys.WbuColorPicker',
    'dsgnsys.WbuColorSelector',
    'dsgnsys.WbuDatePicker',
    'dsgnsys.WbuDrillDown',
    'dsgnsys.WbuEmptyState',
    'dsgnsys.WbuFontAndColorPicker',
    'dsgnsys.WbuMultilineTextInput',
    'dsgnsys.WbuNotificationBanner',
    'ThumbnailItemData',
    'dsgnsys.WbuToggleSwitch',
    'GfppMainActionDefinition'
])
